


<template>
<div class="onboarding-pullout pullout-panel">
  <div class="bkg"></div>
  <div class="onboarding-list">


    <div class="onboarding-scroll" v-if="!detailPanel">
      <img v-if="$store.state.easySetup.getStarted.agreed" class="w-full" src="/img/screens/easy-setup/pullouts/easy-setup-get-started-agree.png?v=10122022" />
      <img v-else class="w-full" src="/img/screens/easy-setup/pullouts/easy-setup-get-started.png?v=10122022" />

      <div class="links">
        <screen-link left="67%" top="1%" width="13.5%" height="5%" data-tgt="" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>
        <screen-link v-if="$store.state.easySetup.getStarted.agreed" left="82%" top="1%" width="15%" height="5%" data-tgt="" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="complete"></screen-link>
        <screen-link left="2.7%" top="98.5%" width="5%" height="4%" data-tgt="agree" dot-class="dot-top-center" data-is-overlay="true" @click.native="()=>{$store.state.easySetup.getStarted.agreed = !$store.state.easySetup.getStarted.agreed}"></screen-link>

      </div>
    </div>
    <div class="onboarding-scroll" v-if="detailPanel === 'revisit'">
      <img class="w-full" src="/img/screens/easy-setup/pullouts/easy-setup-get-started-revisit.png?v=10122022" />
      <div class="links">

        <screen-link left="93%" top="1%" width="6%" height="4%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>


      </div>
    </div>



  </div>



</div>
</template>

<script>
import ScreenLink from "@/components/ScreenLink";

export default {
    name: "easy-setup-docs-pullout",
  components: {ScreenLink},
  props: {},
    data: function(){
        return {
          detailPanel: null,
          agreed: false
        }
        },
    mounted() {
      if(this.$route.query.level !== undefined){
        this.detailPanel = this.$route.query.level;
      }
    },

    watch: {
      $route: function(next){
        if(next.query.level !== undefined){
          this.detailPanel = next.query.level;
        }
      }
    },

    methods: {

      complete: function(){
        this.$store.state.easySetup.getStarted.completed = true;
        this.$emit('close');
      },

      showDetails: function(e){
          this.detailPanel = e.target.dataset.tgt;
let query = {...this.$route.query};
          query.level=e.target.dataset.tgt;
          this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query });
      },

      onLinkClick: function(e){
        console.log(e);
        this.$emit('link', e);
      }
    },
    computed: {}
}
</script>

<style scoped>


.onboarding-pullout {
  width: 100%;
  position: absolute;
  top: calc((60/920) * 100%);
  height: calc(((920 - 60)/920) * 100%);
}

.onboarding-pullout .bkg {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  background-color: black;
  opacity: 0.4;
}

.onboarding-pullout img {
  display: block;
}


.onboarding-list {

  position: absolute;
  width: calc((600/1580) * 100% + 15px);
  height: 100%;

  right: 0;
  display: flex;
  flex-direction: column;

}



.onboarding-scroll {
  position: relative;

  overflow-y: scroll;

}

.w-full {
  width: 100%;
}

.links {

}

</style>
